import { useState, useEffect } from "react";
import DataTable from "react-data-table-component";
import api from "../services/api";
import Modal from "react-modal";
import EditPersona from "./EditPersona"; // Importa el componente de edición
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPencil, faSquarePlus, faSquareMinus } from "@fortawesome/free-solid-svg-icons";

Modal.setAppElement("#root");

export default function ListPersona() {
    const [personas, setPersonas] = useState([]);
    const [searchTerm, setSearch] = useState(sessionStorage.getItem("searchTermPersona") || "");
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [personaSeleccionada, setPersonaSeleccionada] = useState(null);

    const leerPersonas = async () => {
            try {
                const response = await api.get(`/leerPersonas`);
            console.log("Personas cargadas:", response.data); // ✅ Verifica que venga IdTipoDocumento
            setPersonas(response.data);
        } catch (error) {
            console.error("Error al leer personas:", error);
        }
    };

    useEffect(() => {
        leerPersonas();
    }, []);

    useEffect(() => {
        sessionStorage.setItem("searchTermPersona", searchTerm);
    }, [searchTerm]);

    const cambiarEstado = async (IdPersona) => {
        try {
            await api.patch(`/personas/cambiarEstado/${IdPersona}`);
            leerPersonas();
        } catch (error) {
            console.log(error);
        }
    };

    const openModal = (persona) => {
        console.log("Persona seleccionada para editar:", persona); // ✅ Verifica que tenga IdTipoDocumento
        setPersonaSeleccionada(persona);
        setModalIsOpen(true);
    };

    const closeModal = () => {
        setModalIsOpen(false);
        setPersonaSeleccionada(null);
    };

    const columnas = [
        { name: 'Email', selector: row => row.Email, sortable: true },
        { name: 'Nombre', selector: row => row.Nombre, sortable: true },
        { name: 'Apellido', selector: row => row.Apellido, sortable: true },
        {name: "Tipo de Documento", selector: row => row.TipoDocumento, sortable: true },
        { name: 'NroDocumento', selector: row => row.NroDocumento, sortable: true },
        { name: 'Edad', selector: row => row.Edad, sortable: true },
        { name: 'Sexo', selector: row => row.Sexo, sortable: true },
        {
            cell: (row) => (
                <button
                    className="button is-small is-info mr-2 icon-pencil"
                    title="Editar"
                    onClick={() => openModal(row)}
                >
                    <FontAwesomeIcon icon={faPencil} />
                </button>
            ),
            ignoreRowClick: true,
            allowOverflow: true,
            button: true,
        },
        {
            cell: (row) => (
                row.estado === 1 ?
                    <FontAwesomeIcon icon={faSquarePlus} style={{ color: "#37ff00", cursor: "pointer" }} size="2xl" onClick={() => cambiarEstado(row.IdPersona)} />
                    :
                    <FontAwesomeIcon icon={faSquareMinus} style={{ color: "#ff0000", cursor: "pointer" }} size="2xl" onClick={() => cambiarEstado(row.IdPersona)} />
            ),
            ignoreRowClick: true,
            AllowOverflow: true,
            button: true,
        }
    ];

    return (
        <div className="columns mt-5 is-gapless">
            <div className="column is-centered" style={{ marginTop: "-10vh" }}>
                <div className="column container is-max-desktop is-half">
                    <label className="label">Lista de personas</label>
                    <input
                        type="text"
                        className="input"
                        name="searchTerm"
                        onChange={(e) => setSearch(e.target.value)}
                        placeholder="Buscar"
                        value={searchTerm}
                    />
                </div>
                <DataTable
                    columns={columnas}
                    data={personas.filter((item) => item.Nombre.toLowerCase().includes(searchTerm.toLowerCase()))}
                />
                <Modal
                    isOpen={modalIsOpen}
                    onRequestClose={closeModal}
                    contentLabel="Editar Persona"
                    style={{
                        content: {
                            marginTop: "1rem",
                            marginBottom: "-2rem",
                            padding: "2rem",
                            borderRadius: "1rem",
                            backgroundColor: "#ffffff",
                            boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                        },
                        overlay: {
                            backgroundColor: "rgba(0,0,0,0.5)",
                        },
                    }}
                >
                    <button onClick={closeModal} className="button is-danger">Cerrar</button>
                    {personaSeleccionada && (
                        <EditPersona
                            persona={personaSeleccionada}
                            onClose={closeModal}
                            onEditSuccess={leerPersonas}
                        />
                    )}
                </Modal>
            </div>
        </div>
    );
}
